<template>
    <div class="offcanvas offcanvas-bottom h-auto" tabindex="-1" id="record_detail_bottom_sheet" style="min-height: 85%">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title">{{ title }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div class="offcanvas-body small pt-1">
            <template v-if="loader_loading">
                <br />
                <div class="text-center text-muted">
                    <font-awesome-icon icon="fas fa-circle-notch" size="2x" spin />
                    <p>Loading data</p>
                </div>
            </template>

            <template v-if="!record_data.id && !loader_loading">
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-muted text-center mb-0">No data available</h4>
                    </div>
                </div>
            </template>

            <template v-if="record_data.id && !loader_loading">
                <div class="row">
                    <div class="col-4">
                        <div class="card border-0 cs-shadow" :class="{ 'cs-card-disabled': record_data.status >= 13 }">
                            <img :src="record_data.voucher_data.img_json['1_13']" class="img-fiuld rounded w-100 align-middle" />
                        </div>

                        <p class="fst-italic text-body-tertiary text-center mb-0">
                            <span style="font-size: 0.6rem">#{{ record_data.short_id }}</span>
                        </p>
                        <br />
                        <div v-if="record_data.voucher_data.lat && record_data.voucher_data.lng" @click="redirectToMap(record_data.voucher_data.lat, record_data.voucher_data.lng, record_data.status)" :class="record_data.status == 13 ? 'text-secondary' : 'text-primary'" class="text-center text-decoration-underline">
                            <font-awesome-icon icon="fas fa-location-dot" size="l" />
                            Location
                        </div>
                        <br />
                    </div>

                    <div class="col ps-0">
                        <div class="card border-0 cs-shadow" :class="{ 'cs-card-disabled': record_data.status >= 13 }">
                            <div class="card-body">
                                <h6 class="card-title mb-1">{{ record_data.voucher_data.name }}</h6>

                                <div class="mb-3">
                                    <small>
                                        <span :class="$parent.$parent.generateRecordStatusClass(record_data.status)" class="badge rounded-pill">{{ record_data.status_str }}</span>
                                        <template v-if="record_data.time_left">
                                            <span class="badge rounded-pill mx-1 text-bg-danger">{{ record_data.time_left }}</span>
                                        </template>
                                    </small>
                                </div>

                                <div v-if="record_data.voucher_data.description">
                                    <small>
                                        <p class="text-secondary mb-1" v-html="$parent.convertNewlineToBr(record_data.voucher_data.description)"></p>
                                    </small>
                                </div>

                                <br />

                                <div class="row text-center">
                                    <div class="col-6">
                                        <p class="mb-0 cs-label">Available From</p>
                                        <p>
                                            {{ record_data.valid_obj.valid_from_date_str }}
                                            <span>
                                                <br />
                                                {{ record_data.valid_obj.valid_from_time_str }}
                                            </span>
                                        </p>
                                    </div>

                                    <div class="col-6">
                                        <p class="mb-0 cs-label">Expired On</p>
                                        <p>
                                            {{ record_data.valid_obj.valid_to_date_str }}
                                            <span>
                                                <br />
                                                {{ record_data.valid_obj.valid_to_time_str }}
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div class="text-center" v-if="record_data.amount">
                                    <p class="mb-0 cs-label">
                                        Price: &nbsp;
                                        <span class="cs-text-gradient fw-bold fs-5">
                                            <span v-if="record_data.amount == '0.00'">FREE</span>
                                            <span v-if="record_data.amount !== '0.00'">{{ record_data.amount_str }}</span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />

                <div class="mx-3">
                    <template v-if="record_data.payment_status">
                        <p class="text-center mb-2">Your <span v-if="record_data.payment_status < 11">last </span>payment status is <b :class="$parent.$parent.generatePaymentStatusClass(record_data.payment_status)">{{ record_data.payment_status_str.toLowerCase() }}</b></p>
                    </template>

                    <div class="d-grid gap-2 mb-2" v-if="record_data.voucher_data.can_redeem_by_user">
                        <button v-if="record_data.status < 13 && record_data.payment_status < 11" @click="redeemVoucher(record_data.payment_status == 10)" :disabled="btn_loading" class="btn btn-lg cs-btn-default cs-bs-primary mb-1">
                            <span v-if="!btn_loading">
                                <span v-if="record_data.amount && record_data.amount != '0.00'">Pay & Redeem (RM {{ record_data.amount }})</span>
                                <span v-if="!record_data.amount || record_data.amount == '0.00'">Redeem</span>
                            </span>
                            <span v-if="btn_loading">
                                <font-awesome-icon icon="fas fa-circle-notch" spin />
                            </span>
                        </button>

                        <button v-if="record_data.status >= 13" disabled class="btn btn-lg btn-secondary">
                            <span v-if="record_data.status == 13">Redeemed</span>
                            <span v-if="record_data.status == 14">
                                <span v-if="record_data.payment_status == 12">Payment Failed</span>
                                <span v-else>Rejected</span>
                            </span>
                        </button>

                        <small v-if="record_data.status >= 13" class="text-center fst-italic">
                            <span v-if="record_data.status == 13">Redeemed on {{ record_data.updated_at_str }}</span>
                            <span v-if="record_data.status == 14">
                                <span v-if="record_data.payment_status == 12">Payment Failed</span>
                                <span v-else>Rejected</span>
                                on {{ record_data.updated_at_str }}
                            </span>
                        </small>
                    </div>

                    <div class="d-grid gap-2 mb-2" v-if="record_data.status < 13 && !record_data.voucher_data.can_redeem_by_user">
                        <button @click="openModal('VIEW_QR', record_data)" :disabled="btn_loading" class="btn btn-lg cs-btn-default cs-bs-primary text-white mb-1">
                            <span v-if="!btn_loading">Show QR</span>
                            <span v-if="btn_loading">
                                <font-awesome-icon icon="fas fa-circle-notch" spin />
                            </span>
                        </button>
                    </div>
                </div>
            </template>

            <ViewRecordQrModal :qr_src="qr_image" :qr_content="record_data.short_id">
            </ViewRecordQrModal>

            <RepaymentModal title="Confirmation"></RepaymentModal>
            <!-- <slot></slot> -->
        </div>
    </div>
</template>

<script>
import ViewRecordQrModal from "./../_modal/ViewRecordQr.vue";
import RepaymentModal from "./../_modal/Repayment.vue";

export default {
    components: {
        ViewRecordQrModal,
        RepaymentModal,
    },
    props: {
        title: String,
        record_data: Object,
    },
    data() {
        return {
            btn_loading: false,
            qr_image: "",
            modal: "",
            repayment_modal: "",
        };
    },
    mounted() {

    },
    methods: {
        openModal(name, params = {}) {
            switch (name) {
                case "VIEW_QR":
                    this.qr_image = "";
                    this.modal = "";
                    const qr = `${app.entry_url}/merchant?id=${btoa(params.short_id)}`;
                    return app.generateQr(qr).then(blob => {
                        if (!blob) {
                            return false;
                        }

                        this.qr_image = URL.createObjectURL(blob);

                        var modal_option = {
                            backdrop: false,
                        };

                        this.modal = new bootstrap.Modal(document.querySelector("#view_record_qr_modal"), modal_option);
                        this.modal.show();
                        // modal.hide();

                        return true;
                    });

                    break;
                case "REPAYMENT":
                    this.repayment_modal = "";
                    var modal_option = {
                        backdrop: false,
                    };
                    this.repayment_modal = new bootstrap.Modal(document.querySelector("#repayment_modal"), modal_option);
                    this.repayment_modal.show();

                    break;
            }
        },

        closeModal() {
            if (this.modal) {
                this.modal.hide();
            }
        },

        redeemVoucher(show_repayment_modal = false) {
            this.btn_loading = true;

            if (show_repayment_modal) {
                this.openModal("REPAYMENT");
                this.btn_loading = false;
                return true;
            }

            return app.redeemRecord(app.device_tag, this.record_data.id).then((response_data) => {
                this.btn_loading = false;

                if (!response_data) {
                    return false;
                }

                if (response_data.payment_data) {
                    return app.getMerchantPaymentMethod(this.record_data.merchant_id).then(payment_method_str => {
                        if (!payment_method_str) {
                            this.btn_loading = false;
                            this.$toast.error("Payment failed, please try again");
                            return false;
                        }

                        this.btn_loading = false;
                        app.makePayment(response_data.payment_data.reference_id, payment_method_str);
                        return true;
                    });
                }

                this.$toast.success("Voucher redeemed successfully");
                this.$parent.bottom_sheet.hide();
                this.$parent.reloadUi();

                return true;
            });
        },

        redirectToMap(lat, lng, record_status) {
            if (record_status != 13) {
                app.redirectToGoogleMaps(lat, lng);
                return true;
            }

            return false;
        }
    },
};
</script>
